export default __webpack_public_path__ + "imgs/a0aaee7509371e7e51c9fb14aa355d13.png";